import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DoodOrderModel} from '@store/order/order.model';
import {NeptingTerminalApiService,} from '@core/services/api/nepting-terminal/nepting-terminal-api.service';


@Injectable({
  providedIn: 'root',
})
export class NeptingTerminalService {

  constructor(private readonly neptingTerminalApi: NeptingTerminalApiService) {
  }

  abortTransaction$() {
    return this.neptingTerminalApi.abortTransaction$();
  }

  changeOrderStatusToPayment$(orderId: string, paymentRef: string): Observable<DoodOrderModel> {
    return this.neptingTerminalApi.changeOrderStatusToPayment$(orderId, paymentRef);
  }
}
